/* @ngInject */
export default class SecuredStorage {
  constructor(
    private localStorageService: angular.local.storage.ILocalStorageService
  ) {}

  public get(key: string) {
    return this.decode(this.localStorageService.get(key));
  }

  public set(key: string, data) {
    this.localStorageService.set(key, this.encrypt(data));
  }

  public remove(key: string) {
    this.localStorageService.remove(key);
  }

  private decode(data) {
    if (!data) {
      return;
    }

    if (angular.isString(data)) {
      const decrypted = atob(data);
      const decoded = decodeURIComponent(decrypted);
      return angular.fromJson(decoded);
    }
  }

  private encrypt(data) {
    if (!data) {
      return;
    }
    const json = angular.toJson(data);
    const encoded = encodeURIComponent(json);
    return btoa(encoded);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/local-storage/secured-storage.service.ts